module.exports = __webpack_public_path__ + "static/4-64ec559f2c162eeb7389f61100b14f2a.jpg";